import client from './client'

const getAllTools = () => client.get('/api/list-tools')

const createNewTool = (body) => {
    console.log(typeof body)
    client.post(`/workflowmodules`, body)
}

const getSpecificTool = (id) => client.get(`/tools/${id}`)


const updateTool = (id, body) => client.put(`/tools/${id}`, body)

const deleteTool = (id) => client.delete(`/tools/${id}`)

export default {
    getAllTools,
    createNewTool,
    getSpecificTool,
    updateTool,
    deleteTool
}
